import { ContactUtils } from '@/util/ContactUtils';
import { useLocation, useModel } from '@umijs/max';
import { useEffect, useMemo } from 'react';

export const useContact = () => {
  const { initialState } = useModel('@@initialState');
  const current = initialState?.currentUser;
  const location = useLocation();

  const contactOptions = useMemo(() => {
    if (!current) {
      return ContactUtils.getContactOptions();
    }

    return ContactUtils.getContactOptions({
      identifier: current.id,
      nickname: current.nickName || current.account,
      email: current.email,
      phone: current.mobile,
      avatar: current.headerUrl || current.facePic,
      company: current.enterpriseName
        ? {
            name: current.enterpriseName,
            data: {
              enterpriseCode: current.enterpriseCode,
              enterpriseId: current.enterpriseId,
            },
          }
        : undefined,
      customAttributes: {
        account: current.account,
        enterpriseCode: current.enterpriseCode,
        enterpriseName: current.enterpriseName,
        userType: current.userType,
      },
    });
  }, [current]);

  useEffect(() => {
    if (!current) {
      ContactUtils.clearSession();
    }
  }, [current]);

  useEffect(() => {
    ContactUtils.hideDialog();
  }, [location.pathname]);

  return contactOptions;
};
